import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { useAddRewardSettingsMutation } from "../../redux/rewardSettingsApi";
import { useGetCryptocurrencyQuery } from "../../redux/cryptocurrencyApi";

import { useTranslation } from "react-i18next";

function AddRewardSettings({ show, onHide }) {
    const { t } = useTranslation();
    const [addData, setAddData] = useState({
        reward_type: "registration_bonus",
        status: "enabled",
        referral_levels: Array.from({ length: 15 }, (_, i) => ({
            level: i + 1,
            reward_level_amount: "",
            status: "enabled"
        }))
    });
    const [addRewardSettings] = useAddRewardSettingsMutation();
    const { data: cryptoResponse } = useGetCryptocurrencyQuery();

    const cryptocurrencies = cryptoResponse?.data || [];

    const handleAddSave = async () => {
        if (!addData.reward_coin_id || !addData.reward_amount || !addData.status || !addData.reward_type) {
            toast.error("Cryptocurrency, Amount, Reward Type, and Status are required!");
            return;
        }

        const payload = {
            ...addData,
            referral_levels: addData.reward_type === "referral_bonus" ? addData.referral_levels : []
        };

        try {
            const response = await addRewardSettings(payload).unwrap();
            if (response.status) {
                toast.success(response.message || "Reward settings added successfully!");
                onHide();
                setAddData({
                    reward_type: "registration_bonus",
                    status: "enabled",
                    referral_levels: Array.from({ length: 15 }, (_, i) => ({
                        level: i + 1,
                        reward_level_amount: "",
                        status: "enabled"
                    }))
                });
            } else {
                toast.error(response.message || "Failed to add reward settings");
            }
        } catch (error) {
            toast.error("Error adding reward settings");
            console.error("Error adding reward settings:", error);
        }
    };

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{t('add_reward_settings')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>

                    <Form.Group className="mb-3">
                        <Form.Label>{t('cryptocurrency')}</Form.Label>
                        <Form.Select
                            value={addData.reward_coin_id || ""}
                            onChange={(e) => setAddData({ ...addData, reward_coin_id: e.target.value })}
                        >
                            <option value="">{t('select_cryptocurrency')}</option>
                            {cryptocurrencies.map((crypto, index) => (
                                <option key={index} value={crypto.id}>
                                    {crypto.coin_name} ({crypto.symbol})
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>{t('amount')}</Form.Label>
                        <Form.Control
                            type="number"
                            step="any"
                            placeholder={t('enter_amount')}
                            value={addData.reward_amount || ""}
                            onChange={(e) => setAddData({ ...addData, reward_amount: e.target.value })}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>{t('reward_type') || 'Reward Type'}</Form.Label>
                        <Form.Select
                            value={addData.reward_type || "registration_bonus"}
                            onChange={(e) => setAddData({ ...addData, reward_type: e.target.value })}
                        >
                            <option value="registration_bonus">{t('registration_bonus') || 'Registration Bonus'}</option>
                            <option value="referral_bonus">{t('referral_bonus') || 'Referral Bonus'}</option>
                        </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>{t('status')}</Form.Label>
                        <Form.Select
                            value={addData.status || "enabled"}
                            onChange={(e) => setAddData({ ...addData, status: e.target.value })}
                        >
                            <option value="enabled">{t('enabled')}</option>
                            <option value="disabled">{t('disabled')}</option>
                        </Form.Select>
                    </Form.Group>

                    {addData.reward_type === "referral_bonus" && (
                        <>
                            <hr />
                            <h5>{t('referral_levels')}</h5>
                            <div style={{ maxHeight: '300px', overflowY: 'auto', paddingRight: '5px' }}>
                                {addData.referral_levels?.map((levelObj, index) => (
                                    <div key={index} className="d-flex mb-2 align-items-center">
                                        <Form.Label className="me-2 mb-0" style={{ minWidth: '80px' }}>
                                            {t('level')} {levelObj.level}
                                        </Form.Label>
                                        <Form.Control
                                            type="number"
                                            step="any"
                                            placeholder={t('reward_level_amount') || 'Reward Amount'}
                                            value={levelObj.reward_level_amount || ""}
                                            onChange={(e) => {
                                                const newLevels = [...(addData.referral_levels || [])];
                                                newLevels[index].reward_level_amount = e.target.value;
                                                setAddData({ ...addData, referral_levels: newLevels });
                                            }}
                                            className="me-2"
                                        />
                                        <Form.Select
                                            value={levelObj.status || "enabled"}
                                            onChange={(e) => {
                                                const newLevels = [...(addData.referral_levels || [])];
                                                newLevels[index].status = e.target.value;
                                                setAddData({ ...addData, referral_levels: newLevels });
                                            }}
                                        >
                                            <option value="enabled">{t('enabled')}</option>
                                            <option value="disabled">{t('disabled')}</option>
                                        </Form.Select>
                                    </div>
                                ))}
                            </div>
                        </>
                    )}
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    {t('close')}
                </Button>
                <Button variant="primary" onClick={handleAddSave}>
                    {t('add_reward_settings')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default AddRewardSettings;
